const Events = {
	namespaced: true,
	state: {
		events: [],
	},
	getters: {
		events(state) {
			return state.events;
		},
	},
	mutations: {
		resetState(state) {
			state.events = [];
		},
		storeEvents(state, events) {
			state.events = events;
		},
		storeEvent(state, event) {
			state.events.unshift(event);
		},
		appendEvents(state, events) {
			for (let i = 0; i < events.length; i++) {
				const event = events[i];
				state.events.push(event);
			}
		},
		updateEvent(state, event) {
			if (state.events.length > 0) {
				state.events = state.events.map((current) => {
					if (current.id === event.id) {
						return Object.assign({}, current, event);
					}
					return current;
				});
			}
		},
		removeEvent(state, event) {
			const index = state.events.findIndex(curr => curr.id === event.id);
			if (index !== -1) state.events.splice(index, 1);
		},
		SOCKET_EVENTS_ADD(state, event) {
			state.events.unshift(event);
		},
		SOCKET_EVENTS_UPDATE(state, event) {
			if (state.events.length > 0) {
				state.events = state.events.map((current) => {
					if (current.id === event.id) {
						return Object.assign({}, current, event);
					}
					return current;
				});
			}
		},
		SOCKET_EVENTS_DELETE(state, eventIds) {
			for (let i = 0; i < eventIds.length; i++) {
				const eventId = eventIds[i];
				for (let j = 0; j < state.events.length; j++) {
					const current = state.events[j];
					if (current.id === eventId) {
						state.events.splice(j, 1);
						break;
					}
				}
			}
		},
		SOCKET_EVENTS_DELETE_PERMANENT(state, eventId) {
			const index = state.events.findIndex(curr => curr.id === eventId);
			if (index !== -1) state.events.splice(index, 1);
		},
	},
	actions: {
		resetData({ commit }) {
			commit('resetState');
		},
		saveEvents({ commit }, events) {
			commit('storeEvents', events);
		},
		addEvent({ commit }, event) {
			commit('storeEvent', event);
		},
		appendEvents({ commit }, events) {
			commit('appendEvents', events);
		},
		removeEvent({ commit }, event) {
			commit('removeEvent', event);
		},
		updateEvent({ commit }, event) {
			commit('updateEvent', event);
		},
	},
};

export default Events;
